<template>
  <div class="block-widget-component-container">
    <dashboard-widget-header :title="config.name" />
    <div
      v-if="loading"
      class="loading-container"
    >
      <loading-bar />
    </div>
    <template v-else>
      <template v-for="(deck, index) in decks" :key="deck.id">
        <carousel
          class="block-carousel"
          :class="{ first: index === 0 }"
          :item-width="351"
          :tile-count="deck.cards.length"
          :tile-type="'block'"
          :show-header="true"
          :view-all-route="deckRoute(deck)"
          @view-all-clicked="viewAllAnalytics(deck)"
        >
          <template #heading>
            {{ deck.title }}
          </template>
          <block-tile
            v-for="card in sortedCards(deck)"
            :key="card.id"
            :asset="cardAsset(card)"
            :asset-completed="cardAssetCompleted(card)"
            :asset-in-progress="cardAssetInProgress(card)"
            :asset-type="card.assetType"
            :featured-image="featuredImage(card)"
            :metadata="metadata(card)"
            :metadata-icon-name="metadataIconName(card)"
            :show-bookmark="true"
            :source="{ type: 'Card', id: card.id }"
            :state="cardAssetState(card)"
            :title="card.title"
            @tile-clicked="handleCardClick(card, deck)"
          />
        </carousel>
      </template>
    </template>
  </div>
</template>

<script>
import BlockTile from '@components/ui/blockTile';
import Carousel from '@components/carousels/carousel';
import DashboardWidgetHeader from '@components/dashboard-widgets/header';
import LoadingBar from '@/components/singletons/loading-bar';

import CardMixin from '@/mixins/card';

export default {
  components: { BlockTile, Carousel, DashboardWidgetHeader, LoadingBar },
  mixins: [CardMixin],
  props: {
    config: {
      type: Object,
    },
    dashboard: {
      type: Object,
    },
  },
  data() {
    return {
      currentCard: null,
      loading: true,
    };
  },
  computed: {
    currentAttachment() {
      if (this.currentCard) {
        return this.$store.getters['attachments/get'][this.currentCard.assetId];
      }
    },
    decks() {
      if (this.config.decks) {
        return [...this.config.decks].sort((a, b) => a.order - b.order).map(deck => this.$store.getters['decks/get'][deck.id]).filter(d => d);
      }
    },
  },
  created() {
    this.loadAssets();
  },
  methods: {
    deckIconUrl(deck) {
      const attachment = this.$store.getters['attachments/get'][deck.iconId];
      return attachment?.url;
    },
    deckRoute(deck) {
      return { name: 'decks#show', params: { deckId: deck.id } };
    },
    handleCardClick(card, parentDeck) {
      this.currentCard = card;
      this.$analytics.events.viewedCard(card, parentDeck, this.config);
      this.$analytics.events.viewedWidget(this.config, card, parentDeck, this.dashboard);
      this.openCard(card, parentDeck);
    },
    loadAssets() {
      const loadPromises = [];
      this.decks.forEach(deck => {
        loadPromises.push(deck.fetchAssets(this.$store));
      });
      Promise.all(loadPromises).then(() => this.loading = false);
    },
    sortedCards(deck) {
      return [...deck.cards].sort((a, b) => a.order - b.order) || [];
    },
    viewAllAnalytics(deck) {
      this.$analytics.events.viewedWidget(this.config, null, deck, this.dashboard);
    },
  },
};
</script>

<style lang="scss" scoped>
.block-widget-component-container {
  @include padded-widget;

  .loading-container {
    height: rem-calc(245);
    display: flex;
    justify-content: center;
    align-items: center;
  }

  .header-text-component {
    font-size: rem-calc(18);
    line-height: rem-calc(24);
    font-weight: $bold;
  }

  .block-carousel {
    &:not(.first) {
      margin-top: rem-calc(80) !important;
    }
  }
}
</style>
